import { render } from "./NotificationRegistryComponent.vue?vue&type=template&id=cb57795a&scoped=true"
import script from "./NotificationRegistryComponent.vue?vue&type=script&lang=js"
export * from "./NotificationRegistryComponent.vue?vue&type=script&lang=js"

import "./NotificationRegistryComponent.vue?vue&type=style&index=0&id=cb57795a&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb57795a"]])

export default __exports__